import React, { useState } from "react";
import BookDetailsModal from "../../modal/bookDetails";
import { useDispatch, useSelector } from "react-redux";
import MakeOfferModal from "../../modal/makeOffer";
import CoverPhotoBaseURL from "../../../util/coverPhotoBaseURL";
import { setUser } from "../../../redux/reducers/userSlice";
import { getWeb3 } from "../../../util/getWeb3";
import DigiBook from "../../../../abis/DigiBook.json";
import "./style.css";
import { Spinner } from "react-bootstrap";
import axios from "axios";
import {
  BuyBook,
  GetMyBooks,
  PutOnSwap,
  RemoveFromSwap,
} from "../../../services/bookService";
import {
  DownloaddBook,
  RemoveEncryptedBook,
} from "../../../services/libraryService";
import { toastMessage } from "../toast";
import LoginModal from "../../modal/login";
import SignupModal from "../../modal/signUp";
import PdfReaderModal from "../../modal/pdfReader";
import { assert } from "chai";

const BookCard = ({
  src,
  isBuy,
  isSwap,
  isPublisher,
  isBookReader,
  item,
  status,
  bookID,
  offerred,
  getPublisherBooks,
  handleOnBuy,
  getBookReadersBooks,
  handleOnSwap,
  token,
}) => {
  const dispatch = useDispatch();
  const [display, setDisplay] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [isOpen2, setOpen2] = useState(false);
  const [isOpen3, setOpen3] = useState(false);
  const [isOpen4, setOpen4] = useState(false);
  const [isOpen5, setOpen5] = useState(false);
  const [loader, setLoader] = useState(false);
  const [loader2, setLoader2] = useState(false);
  const [loader3, setLoader3] = useState(false);
  const [loader4, setLoader4] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [offerBookList, setOfferBookList] = useState(null);
  const [selectedBook, setSelectedBook] = useState(null);
  const user = useSelector((state) => state.root.user);
  const [address, setAddress] = useState("");
  const showButton = (e) => {
    e.preventDefault();
    setDisplay(true);
  };
  const hideButton = (e) => {
    e.preventDefault();
    setDisplay(false);
    console.log("leave");
  };
  const openModal = () => {
    setOpen(true);
    setDisplay(false);
  };
  const closeModal = () => {
    setOpen(false);
  };
  const openModal3 = () => {
    setOpen3(true);
  };
  const closeModal3 = () => {
    setOpen3(false);
  };
  const openModal4 = () => {
    setOpen4(true);
  };
  const closeModal4 = () => {
    setOpen4(false);
  };
  const openModal5 = () => {
    setOpen5(true);
  };
  const closeModal5 = () => {
    setOpen5(false);
  };
  const handleBookSelection = (item) => {
    setSelectedBook(item);
  };
  const openModal2 = async () => {
    let obj = [];
    setSelectedBook(null);
    setOfferBookList(null);
    setLoader4(true);
    await GetMyBooks(user?.token)
      .then((res) => {
        if (res.statusText === "OK") {
          obj = res.data;
          setOfferBookList(obj);
          setLoader4(false);
          setOpen2(true);
          setDisplay(false);
        } else {
          setLoader4(false);
        }
      })
      .catch((error) => {
        console.log(error.message);
        setLoader4(false);
      });
  };
  const closeModal2 = () => {
    setOpen2(false);
  };
  const buyBook = async () => {
    await axios
      .get(
        "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=bitcoin%2Cethereum&order=market_cap_desc&per_page=100&page=1&sparkline=false"
      )
      .then(async (res) => {
        let price = 0;
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].name === "Ethereum") {
            price = res.data[i].current_price;
          }
        }
        let convertedPrice = item?.price / price;
        console.log("Converted", convertedPrice);
        let web3 = await getWeb3(null);
        const accounts = await web3?.eth.getAccounts();
        const networkId = await web3?.eth.net.getId();
        const networkData = DigiBook.networks[networkId];
        setLoader2(true);

        if (networkData) {
          const abi = DigiBook.abi;
          const address = networkData.address;
          const contract = new web3.eth.Contract(abi, address);
          console.log(item.publisher);
          try {
            const x = await contract.methods
              .buy(item.publisher.walletaddress, accounts[0], item._id)
              .send({
                from: accounts[0],
                value: web3.utils.toWei(convertedPrice.toString(), "ether"),
              });
            let obj = {
              library: item._id,
              status: 1,
              token: x.events.Approval.returnValues.tokenId,
            };
            await BuyBook(user?.token, obj)
              .then((res) => {
                if (res.statusText === "OK") {
                  toastMessage("Book Bought Successfully", "success");
                  let resp = {
                    ...user,
                    books: user?.books + 1,
                  };
                  dispatch(setUser(resp));
                  handleOnBuy();
                } else {
                  toastMessage(res.data, "error");
                }
                setLoader2(false);
              })
              .catch((err) => {
                setLoader2(false);
                toastMessage(
                  err?.response?.data?.message
                    ? err.response.data.message
                    : "Check your Network Connection",
                  "error"
                );
              });
          } catch (err) {
            console.log(err);
            setLoader2(false);
            toastMessage(err.message, "error");
          }
        } else {
          toastMessage("Smart Contract not deployed!", "error");
        }
      })
      .catch((error) => console.log(error));
  };
  const putBookonSwap = async () => {
    setLoader(true);
    let obj = { _id: bookID };
    await PutOnSwap(user?.token, obj)
      .then((res) => {
        if (res.statusText === "OK") {
          toastMessage("Book is now available for Swap", "success");
          getBookReadersBooks();
        } else {
          toastMessage(res.data, "error");
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        toastMessage(
          err?.response?.data?.message
            ? err.response.data.message
            : "Check your Network Connection",
          "error"
        );
      });
  };
  const removeBookfromnSwap = async () => {
    setLoader3(true);
    let obj = { _id: bookID };
    await RemoveFromSwap(user?.token, obj)
      .then((res) => {
        if (res.statusText === "OK") {
          toastMessage("Book is no longer available for Swap", "success");
          getBookReadersBooks();
        } else {
          toastMessage(res.data, "error");
        }
        setLoader3(false);
      })
      .catch((err) => {
        setLoader3(false);
        toastMessage(
          err?.response?.data?.message
            ? err.response.data.message
            : "Check your Network Connection",
          "error"
        );
      });
  };
  const delay = (ms = 1000) => new Promise((r) => setTimeout(r, ms));
  const downloadFile = async () => {
    setIsDownloading(true);

    let obj = { name: item?.file };
    await DownloaddBook(user?.token, obj)
      .then(async (res) => {
        if (res.statusText === "OK") {
          window.open(`${CoverPhotoBaseURL}${res.data}`, "_blank");
          let obj2 = {
            name: res.data,
          };
          await delay();
          await RemoveEncryptedBook(obj2)
            .then((res) => {
              console.log(res.data);
            })
            .catch((error) => {
              console.log(error.message);
            });
        }
        setIsDownloading(false);
      })
      .catch((error) => {
        console.log(error.message);
        setIsDownloading(false);
      });
  };
  return (
    <div
      className="recent-activity-col"
      onMouseEnter={(e) => showButton(e)}
      onMouseLeave={(e) => hideButton(e)}
      data-aos="fade-up"
      data-aos-duration="500"
    >
      <div className="imgcontainer">
        <img
          src={item?.coverimage && `${CoverPhotoBaseURL}${item?.coverimage}`}
          alt="driptivity-img3"
          className="recent-activity-img"
        />
      </div>
      {isBuy ? (
        <div className="recent-activity-text">
          <div className="d-flex flex-column">
            <span>${item.price}</span>
          </div>
        </div>
      ) : null}
      {isPublisher ? (
        <div className="recent-activity-text">
          <div className="d-flex flex-column">
            <div className="d-flex flex-row justify-content-between">
              <label className="recent-activity-text2">Total Copies</label>
              <span>{item?.copies}</span>
            </div>
          </div>
          <div className="d-flex flex-column">
            <div className="d-flex flex-row justify-content-between">
              <label className="recent-activity-text2">Remaining Copies</label>
              <span>{item?.remainingCopies}</span>
            </div>
          </div>
        </div>
      ) : null}
      {display ? (
        <div
          className={`${isBuy ? "btns-show" : null} ${
            isSwap ? "btns2-show" : null
          } ${isPublisher ? " btns3-show " : null}${
            isBookReader && status === 1 ? " btns-show5" : null
          } ${isBookReader && status != 1 ? "btns-show4" : null}`}
        >
          {isBuy ? (
            user?.isLoggedIn ? (
              item?.bought ? (
                <a className="custom-btn2">Owned</a>
              ) : item?.remainingCopies === 0 ? (
                <a className="custom-btn2">Out of stock!</a>
              ) : loader2 ? (
                <a role="button" className="custom-btn">
                  <Spinner animation="grow" size="sm" />
                </a>
              ) : (
                <a className="custom-btn" onClick={buyBook} role={"button"}>
                  Buy
                </a>
              )
            ) : (
              <a className="custom-btn" onClick={openModal3} role={"button"}>
                Buy
              </a>
            )
          ) : null}
          {isSwap ? (
            user?.isLoggedIn ? (
              offerred ? (
                <a className="custom-btn2">Offerred</a>
              ) : loader4 ? (
                <a role="button" className="custom-btn">
                  <Spinner animation="grow" size="sm" />
                </a>
              ) : (
                <a role="button" className="custom-btn" onClick={openModal2}>
                  Make Offer
                </a>
              )
            ) : (
              <a role="button" className="custom-btn" onClick={openModal3}>
                Make Offer
              </a>
            )
          ) : null}
          <a role="button" className="custom-btn" onClick={openModal}>
            View Details
          </a>
          {isBookReader && (
            <>
              <a role="button" className="custom-btn" onClick={openModal5}>
                Read
              </a>
              {status === 1 ? (
                loader ? (
                  <a role="button" className="custom-btn">
                    <Spinner animation="grow" size="sm" />
                  </a>
                ) : (
                  <a
                    role="button"
                    className="custom-btn"
                    onClick={putBookonSwap}
                  >
                    Swap
                  </a>
                )
              ) : loader3 ? (
                <a role="button" className="custom-btn3">
                  <Spinner animation="grow" size="sm" />
                </a>
              ) : (
                <a
                  role="button"
                  className="custom-btn3"
                  onClick={removeBookfromnSwap}
                >
                  Remove from Swap
                </a>
              )}
              <a role="button" className="custom-btn" onClick={downloadFile}>
                {isDownloading ? (
                  <Spinner animation="grow" size="sm" />
                ) : (
                  "Download"
                )}
              </a>
            </>
          )}
          {isPublisher && (
            <a role="button" className="custom-btn" onClick={openModal5}>
              Read
            </a>
          )}
        </div>
      ) : null}
      <BookDetailsModal
        HideModal={closeModal}
        src={src}
        item={item}
        openModal={isOpen}
        getPublisherBooks={getPublisherBooks}
      />
      <MakeOfferModal
        HideModal={closeModal2}
        openModal={isOpen2}
        booklist={offerBookList}
        handleBookSelection={handleBookSelection}
        selectedBook={selectedBook}
        bookID={bookID}
        OnSwap={handleOnSwap}
        token={token}
      />
      <LoginModal
        openModal={isOpen3}
        HideModal={closeModal3}
        OpenModal1={openModal4}
        setAddress={setAddress}
      />
      <SignupModal
        openModal={isOpen4}
        HideModal={closeModal4}
        address={address}
      />
      <PdfReaderModal openModal={isOpen5} HideModal={closeModal5} item={item} />
    </div>
  );
};

export default BookCard;
